
export enum DiscountType
{
    Percent = "percent",
    LimitedPercent = "limited-percent",
    FixedPrice = "fixed-price"
}
